/**
 * The note types staff pick from and see as labels: the Patient 360 notes
 * filter bar and the order page's notes card read this one map.
 *
 * PRX-208: `stage_note` is a note added from a stage's page on the order page
 * (OrderStageDialog).
 */
export interface NoteTypeOption {
  value: string;
  label: string;
  color: string;
}

export const NOTE_TYPES: readonly NoteTypeOption[] = [
  { value: 'clinical', label: 'Clinical', color: '#4caf50' },
  { value: 'billing', label: 'Billing', color: '#2196f3' },
  { value: 'delivery', label: 'Delivery', color: '#ff9800' },
  { value: 'troubleshooting', label: 'Troubleshooting', color: '#f44336' },
  { value: 'subscription', label: 'Subscription', color: '#9c27b0' },
  { value: 'stage_note', label: 'Stage note', color: '#00818F' },
];

/** The label for a note type; a type not in the map shows as stored. */
export function noteTypeLabel(type: string): string {
  return NOTE_TYPES.find((t) => t.value === type)?.label ?? type;
}

/** The colour for a note type; a type not in the map is grey. */
export function noteTypeColor(type: string): string {
  return NOTE_TYPES.find((t) => t.value === type)?.color ?? '#757575';
}
